module.exports = __webpack_public_path__ + "assets/img/forum-icon.68cdb9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forum-icon.png
// module id = wiHA
// module chunks = 1